FiltersMdl.service( 'MobileFiltersSrv', [function() {
	return {

		filterOn: true,
		searchOn: false

	}
}]);